import React from "react";

const ArrowRight = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path
        d="M8.17969 6.58123L8.17969 18.4212C8.17969 19.3812 9.33969 19.8612 10.0197 19.1812L15.1997 14.0012C16.0297 13.1712 16.0297 11.8212 15.1997 10.9912L13.2297 9.02123L10.0197 5.81123C9.33969 5.14123 8.17969 5.62123 8.17969 6.58123Z"
        fill="#BF1D2D"
      />
    </svg>
  );
};

export default ArrowRight;
